import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadAufmacher, loadVerzeichnisse } from "./startseite-actions.js";
import { startseiteService } from "../service/startseite-service.js";

/** Verzeichnisse — einmal je Besuch, über `fireOnce` angestoßen. */
export const loadVerzeichnisseEffect = actions$.pipe(
  ofType(loadVerzeichnisse.action),
  switchMap(() =>
    startseiteService.ladeVerzeichnisse().pipe(
      map((daten) => loadVerzeichnisse.success(daten)),
      catchError((err) => of(loadVerzeichnisse.fail(err))),
    ),
  ),
);

/**
 * Aufmacher — je gemerktem Gebiet einer.
 *
 * `switchMap`: Wer schnell zwischen Gebieten wechselt, soll das zuletzt
 * gewählte sehen, nicht das zuletzt eingetroffene.
 */
export const loadAufmacherEffect = actions$.pipe(
  ofType(loadAufmacher.action),
  switchMap(({ payload: fuer }) =>
    startseiteService.ladeAufmacher(fuer).pipe(
      map((dokument) => loadAufmacher.success({ fuer, dokument })),
      catchError((err) => of(loadAufmacher.fail(err))),
    ),
  ),
);

export const startseiteEffects = [loadVerzeichnisseEffect, loadAufmacherEffect];
